import { render, staticRenderFns, recyclableRender, components } from "./diy-page.vue?vue&type=template&id=6806f8f4&"
var renderjs
import script from "./diy-page.vue?vue&type=script&lang=js&"
export * from "./diy-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/diy-page/diy-page.vue"
export default component.exports